import React 			from 'react';
import PropTypes 		from 'prop-types';
import BLComponent 		from '../core/_BLComponent.jsx';
import GalleryCard 		from '../common/_GalleryCard.jsx';
import PDUtil			from './_ProductDetailUtil';

export default class ItemOverview extends BLComponent 
{
	constructor( props, context ) 
	{
		super(props, context);
	}

	render() {
		this.renderData	= PDUtil.buildRenderData( this.props.item, true );
		const {classes = '', hideImages = false} = this.props;

		return (
			<article className={'item-overview-card ' + classes}>
				{!hideImages ? this.renderImageArea() : null}
				{this.renderInformation()}
				{this.props.children ? <div className="item-overview-card__children">{this.props.children}</div> : null}
			</article>
		);
	}

	renderImageArea() {
		let	images = this.renderData.images;

		console.log(images);

		return (
			<section className="item-overview-card__image-area">
				<GalleryCard classes="gallery-card--auto-height gallery-card--no-border gallery-card--spaced" images={images} active={0} wantedList={{enabled: false}}/>
			</section>
		);
	}

	renderInformation() {
		const	itemBasic	= this.props.item.dmItemDetail.dmItem.dmBasic;
		const	{ typeItem, strDescription } = itemBasic;
		const	strDescNorm	= strDescription.replace( /<!--[\s\S]*?-->/g, '' );

		return (
			<section className="item-overview-card__information">
				<h2 className="section-title text--xl-title">{$T("PRODUCT_INFORMATION",[blapp.util.getTypeName( typeItem, false, blapp.sitelang.getCurrentLanguage())])}</h2>
				<ul className="item-overview-card__product-info">
				{
					this.renderData.stats.map( 
						(stat, key) => 
							<li key={key}><span className="l-margin-right--sm">{stat.label}:</span>{stat.content}</li>
					)
				}
				</ul>
				{
					!_.isEmpty( this.renderData.cobrandings ) ?
					<div className="l-margin-top"> 
						<strong className="l-block l-margin-bottom--sm text--small-title text--bold">{$T("COBRANDING")}</strong>
						{
							this.renderData.cobrandings.map(
								(brand, key) => 
									<a key={key} href={brand.link}>{brand.name}{this.renderData.cobrandings.length - 1 > key ? ', ' : ''}</a>
							)
						}
					</div>
					: 
					null
				}
				{
					strDescNorm ? 
					<div className="l-margin-top"> 
						<strong className="l-block l-margin-bottom--sm text--small-title text--bold">{$T("ADDITIONAL_NOTES")}</strong>
						{strDescNorm}
					</div>
					: 
					null
				}
			</section>
		);
	}

};


ItemOverview.propTypes = {
		classes: PropTypes.string
	,	user: PropTypes.object
}

var $T = BLComponent.createTextMap(
	{
		"PRODUCT_INFORMATION":
		{
			"en":	"{{$0}} information"
		,	"kr":	""
		,	"es":	"Información de {{$0}}"
		}
	,	"COBRANDING":
		{
			"en":	"Co-branding"
		,	"kr":	""
		,	"es":	"Marca compartida"
		}
	,	"ADDITIONAL_NOTES":
		{
			"en":	"Additional notes"
		,	"kr":	""
		,	"es":	"Notas adicionales"
		}
	}
);
